import { render } from "./CustomerBpmModal.vue?vue&type=template&id=74062e8f"
import script from "./CustomerBpmModal.vue?vue&type=script&lang=js"
export * from "./CustomerBpmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__